import { FocusEvent } from 'react'
import { useEditMode } from '../contexts/edit-mode.context'

export const releaseReadonlyOnFocus = (
  e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>
) => {
  e.currentTarget.removeAttribute('readonly')
}

type BlockBrowserAutofillResult = {
  blockBrowserAutofill: boolean
  domFieldName: string | undefined
  domFieldId: string | undefined
  htmlInputProps: Record<string, unknown>
}

export const useBlockBrowserAutofill = (
  fieldName?: string,
  enabled?: boolean
): BlockBrowserAutofillResult => {
  const { suppressAutofill } = useEditMode()
  const blockBrowserAutofill = (enabled ?? suppressAutofill) && !!fieldName

  if (!blockBrowserAutofill) {
    return {
      blockBrowserAutofill: false,
      domFieldName: fieldName,
      domFieldId: undefined,
      htmlInputProps: {},
    }
  }

  return {
    blockBrowserAutofill: true,
    domFieldName: `mf-${String(fieldName)}`,
    domFieldId: `manual-${String(fieldName)}`,
    htmlInputProps: {
      autoComplete: 'new-password',
      readOnly: true,
      onFocus: releaseReadonlyOnFocus,
      'data-lpignore': 'true',
      'data-1p-ignore': 'true',
      'data-form-type': 'other',
    },
  }
}
